import React from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

export const IMAGES ={
  colsubidio: "/colsubsidio/logo-col.png",
  funcol: "/funcol/logo-funcol.png",
  footerColsubsidio: "https://cibercolegios.com/Colegios-ciber/Colsubsidio/VigiladogrishorizontalF.png"
}

export const GLOBALS={
  activeAffiliation:"VIGEN"
}

export const MESSAGES = {
  "OLVIDO_CONTRASENIA": "Si ha olvidado alguno de sus datos de acceso por favor ingrese a continuación la dirección de correo electrónico registrada en el sistema, para enviarle via correo electrónico su acceso.",
  "CIB-GEN-0017": "Apreciado usuario, este portal es exclusivo para servicios de educación. Actualmente no se encuentra registrado en ninguna de nuestras instituciones educativas.",
  "CIB-GEN-0022": "Su sesión ha expirado",
  "CIB-GEN-0002": "Los datos ingresados o contraseña son incorrectos: En caso de haberlos olvidado, comuníquese con el administrador del sistema de su institución",
  "CIB-GEN-0023": "Su afiliación no está vigente",
  "CIB-GEN-0024": "No tiene beneficiarios disponibles",
  "CIB-GEN-0026": "El tiempo del proceso de inscripción en el colegio seleccionado ha finalizado, por favor seleccione otra institución",
  "CIB-GEN-0027": "Ha ocurrido un error inesperado por favor comuníquese con el administrador del sistema",
  "CIB-GEN-0028": "Estimado Padre de Familia, le informamos que en este momento no se encuentra habilitado ningún proceso de inscripción, si usted presenta alguna inquietud le agradecemos comunicarse a la línea 7457900 en Bogotá o línea Nacional 018000 94 7900 de Lunes a Sábado de 07:00 a.m. a 07:00 p.m., en donde le podrán ayudar al respecto.",
  "ANY": "Error Desconocido Por favor consulte al administrador para tener más contexto del error",
  "SUCCESS": "Hemos enviado un reporte para la corrección de la fecha de nacimiento al área de Afiliaciones, un funcionario de Colsubsidio lo contactará o acérquese con el documento de identidad del beneficiario al Centro de Servicios más cercano.",
  "SUCCESS_FUNCOL": "Hemos enviado un reporte para la corrección de la fecha de nacimiento al Área de Admisiones y Matrículas, un funcionario del Colegio Fundación Colombia lo contactará o envíe un correo a admisiones@funcol.edu.co con el documento de identidad del aspirante.",
  "SUCCESS_BAC": "Hemos enviado un reporte para validar su solicitud, un funcionario de Colsubsidio lo contactará o en su defecto comuníquese o acérquese con el documento de identidad del aspirante, a cualquiera de nuestras sedes educativas.",
  "CIB-GEN-6665": "Problema recuperando su password, contáctese con el administrador",
  "CIB-GEN-0029": "La inscripción no se puede realizar. El número de cédula ingresado no se encuentra registrado como funcionario del Grupo Bancolombia. Si usted cumple con este requisito, por favor enviar al correo admisiones@funcol.edu.co, su nombre completo, número de cédula de ciudadanía, dependencia en Bancolombia y en el término de 48 horas daremos la respuesta correspondiente",
  "CIB-GEN-0030":"El aspirante no puede ser inscrito, ya que se encuentra registrado como aspirante o estudiante del Colegio %COLEGIO%",
  "CIB-GEN-0031":"El tiempo del proceso de inscripción en el colegio seleccionado ha finalizado",
  "VIGEN": "(Afiliación Vigente)",
  "RETIR": "(Afiliación Retirado)",
  "WELCOME_MESSAGE_COLSUBSIDIO": "Tenga presente que: Al ingresar la información a la plataforma usted declara la veracidad de la misma, Colsubsidio se reserva el derecho de finalizar anticipadamente el proceso de matrícula en caso de existir información falsa o cualquier otro factor externo que pudiera comprometer la transparencia y seguridad del proceso.",
  "NOTE_COLSUBSIDIO": "NOTA IMPORTANTE: El proceso de matrícula se realiza únicamente en el colegio y grado que usted seleccione, no es posible realizar cambios durante el proceso de matrícula ni una vez finalizado el proceso.",
  "WELCOME_MESSAGE_FUNCOL": "Tenga presente que: Al ingresar la información a la plataforma usted declara la veracidad de la misma, el Colegio Fundación Colombia se reserva el derecho de finalizar anticipadamente el proceso de matrícula en caso de existir información falsa o cualquier otro factor externo que pudiera comprometer la transparencia y seguridad del proceso." 

};



  class CiberAlerts extends React.Component {

  render() {
    let code = '';
    let message = '';
    console.log(this.props);
    if (this.props.code) {
      code = this.props.code
      message = MESSAGES[code]
    } else {
      try {
        code = this.props.error.graphQLErrors[0].extensions.code;
        message = MESSAGES[code];
      } catch (e) {
        try {
          code = this.props.error.networkError.result.message;
          message = MESSAGES[code];
        } catch (e) {
          code = "ANY";
          message = MESSAGES["ANY"]
        }
      }
    }

    if (code === "CIB-GEN-0025") {
      let grade =  this.props.error.graphQLErrors[0].extensions.message;
      if (grade === "Level not corresponding for age") {
        grade = null;
      }
      if (window.location.href.indexOf("/bac/") >= 0) {
        return (
          <Alert variant="warning">
            <Alert.Heading>¡La solicitud no ha podido procesarse!</Alert.Heading>
            <h5>
              El aspirante no puede ser inscrito en el grado seleccionado, por alguna de las siguientes razones:
            </h5>
            <ul>
              <li>1.No cumple con la edad requerida para el ciclo seleccionado, en este caso dar clic en el botón reportar para enviar la información al Colegio.
              </li>
              <li>2. La fecha de nacimiento del aspirante no se encuentra bien, en este caso dar clic en el botón reportar para enviar la información al Colegio.
              </li>
              <li>
                3. Seleccionó un ciclo incorrecto, por favor realice el cambio e intente nuevamente con el botón "Diligenciar inscripción".
              </li>
            </ul>
            <hr/>
            <Button className="btn btn-info" onClick={() => this.props.callBack()}>Reportar</Button>
          </Alert>
        );
      } else {
        return (
          <Alert variant="warning">
            <Alert.Heading>¡La solicitud no ha podido procesarse!</Alert.Heading>
            <h5>El beneficiario no puede ser inscrito en el grado seleccionado,
              {grade ? " ya que por el rango de edad solo puede ser inscrito en el grado: " + grade : "debido a su rango de edad"}
            </h5>
            <ul>
              <li>1. Si desea inscribirlo en el grado designado, realice la respectiva corrección en el formulario y
                haga
                clic en Diligenciar Inscripción.
              </li>
              <li>2. Si la fecha de nacimiento del beneficiario no corresponde, dar clic en el botón reportar para
                corregir la información.
              </li>
            </ul>
            <hr/>
            <Button className="btn btn-info" onClick={() => this.props.callBack()}>Reportar</Button>
          </Alert>
        );
      }

    }
    else if (["CIB-GEN-0017", "CIB-GEN-0022", "Token is not matching with the user id sent"].indexOf(code) >= 0) {
      localStorage.removeItem("X-GigyaOnUserData-X");
      sessionStorage.removeItem("X-GigyaCookies-X");
      if (window.location.href.indexOf("/inscripcion") >= 0 || window.location.href.indexOf("/bridge")>=0 ) {
        let complement = "/colsubsidio/inscripcion/"
        if (window.location.href.indexOf("/bac/") >= 0) {
          complement = "/colsubsidio/bac/affiliate/inscripcion/";
        } else if(window.location.href.indexOf("/bridge") >= 0) {
          complement = "/colsubsidio/bridge";
        }
        localStorage.removeItem("X-GigyaOnUserData-X")
        sessionStorage.removeItem("auth_token")
        window.location.assign(`/colsubsidio/sso?returnUrl=${complement}`); // relative to domain
      }
      return (
        <Alert variant="warning">
          <Alert.Heading>¡La solicitud no ha podido procesarse!</Alert.Heading>
          <h5>{message}
          </h5>
        </Alert>
      )
    } else {

      if (["CIB-GEN-0030"].indexOf(code) >= 0) {
        let complement = "/colsubsidio/inscripcion/"
        if (window.location.href.indexOf("/bac/") >= 0) {
          complement = "BAC";
        } else if (window.location.href.indexOf("/funcol/") >= 0) {
          complement = "Fundación Colombia";
        } else {
          complement = "Colsubsidio"
        }
        message = message.replace("%COLEGIO%", complement);
      }

      return (
        <Alert variant="warning">
          <Alert.Heading>¡La solicitud no ha podido procesarse!</Alert.Heading>
          <h5>{message}
          </h5>
        </Alert>
      )
    }
  }
}

export default CiberAlerts;
